import { render, staticRenderFns } from "./StructuresCreate.vue?vue&type=template&id=75ec9188&"
import script from "./StructuresCreate.vue?vue&type=script&lang=ts&"
export * from "./StructuresCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports